import { modalController } from "@ionic/vue";
import { useStore } from 'vuex';

import useAppStorage from '@/composables/useAppStorage';
import ProfileModal from "@/components/app/ProfileModal";

const { getKeyWithExpire, setKeyWithExpire } = useAppStorage();

export default () => {
  const store = useStore();

  const updateReminderDate = () =>{
    setKeyWithExpire('lastCategoryReminderDate', new Date().toISOString(), 7 * 24 * 60 * 60 * 1000);
  };

  const checkProfileDetails = async () => {
    try {
      await store.dispatch('profile/setProfileDetails');

      const profileCategories = store.getters['profile/getUserCategories'];
      const profileProfessions = store.getters['profile/getUserProfessions'];
      const noCategory = store.getters['profile/getNoCategory'];

      const categoriesByProfessionId = await store.dispatch(
        'profile/fetchCategoriesByProfessionId',
        profileProfessions.map(p => p.profession_id));

      const hasNoProfileCategories =
        (!profileCategories || profileCategories.length === 0) &&
        noCategory !== 1 &&
        categoriesByProfessionId.length;

      const hasNoProfileProfessions = !profileProfessions || profileProfessions.length === 0;

      if (hasNoProfileCategories || hasNoProfileProfessions) {
        const lastReminderDate = await getKeyWithExpire('lastCategoryReminderDate');
        const now = new Date();
        const periodPassed = lastReminderDate && (now - new Date(lastReminderDate)) > 7 * 24 * 60 * 60 * 1000;
        
        if (!lastReminderDate || periodPassed) {
          const modal = await modalController.create({
            component: ProfileModal,
            backdropDismiss: true,
            keyboardClose: true,
          });
          await modal.present();
          updateReminderDate();
        }
      }
    } catch (error) {
      console.error('Error fetching profile details:', error);
    }
  };

  return {
    checkProfileDetails,
  };
};
